export function formatTimeDurationFromSeconds(seconds: number): string {
  const s = seconds % 60;
  const m = ((seconds % 3600) - s) / 60;
  const h = (seconds - m * 60 - s) / 3600;

  return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s
    .toString()
    .padStart(2, '0')}`;
}

export function formatNumberForCurrency(
  value?: number,
  withCurrency = false,
  defaultTo: number | string = 0,
): string {
  if (!value && typeof defaultTo === 'string') {
    return defaultTo;
  }
  if (!value) {
    value = defaultTo as number;
  }

  return `${new Intl.NumberFormat('de-CH', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(value)}${withCurrency ? ' CHF' : ''}`;
}

export function formatNumber(value?: number, defaultTo: number | string = 0): string {
  if (!value && typeof defaultTo === 'string') {
    return defaultTo;
  }
  if (!value) {
    value = defaultTo as number;
  }

  return new Intl.NumberFormat('de-CH').format(value);
}
